module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//fire_2.png?v=6a72e2a1";